import React, { createContext, useState, useContext, useCallback } from 'react';

export const ManagersContext = createContext();

export const useManagers = () => useContext(ManagersContext);
